// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"NewPasswordPage_container__3UroW","success":"NewPasswordPage_success__3OMt8"};